const c = {
  name: "Skull",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.7,16.7c0.9-0.9,2.1-1.7,3.3-1.7c1.4,0,2.2,1.1,2.6,2c0.4,1,0.4,2.1,0.4,3c0,2.2-1.8,4-4,4
			c-2.2,0-4-1.8-4-4C11,18.8,11.8,17.5,12.7,16.7z M14.1,18.1C13.4,18.8,13,19.6,13,20c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2
			c0-0.8-0.1-1.6-0.3-2.3C16.5,17.1,16.2,17,16,17C15.6,17,14.8,17.4,14.1,18.1z"/>
		<path class="st0" d="M24,15c-1.4,0-2.2,1.1-2.6,2c-0.4,1-0.4,2.1-0.4,3c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4c0-1.2-0.8-2.5-1.7-3.3
			C26.5,15.8,25.2,15,24,15z M23,20c0-0.8,0.1-1.6,0.3-2.3c0.2-0.6,0.5-0.7,0.7-0.7c0.4,0,1.2,0.4,1.9,1.1c0.7,0.7,1.1,1.5,1.1,1.9
			c0,1.1-0.9,2-2,2C23.9,22,23,21.1,23,20z"/>
		<path class="st0" d="M32.7,0.1C30-0.4,27.6,2,28.1,4.7l0,0c0.1,0.5,0.3,0.9,0.5,1.3l-2.3,2.3C24.3,7.5,22.2,7,20,7
			c-2.2,0-4.3,0.5-6.2,1.4L11.4,6c0.2-0.4,0.4-0.8,0.5-1.3l0,0C12.4,2,10-0.4,7.3,0.1l0,0C5.6,0.4,4.4,1.7,4.1,3.2l0,0.1v0
			C4,3.7,3.7,4,3.4,4.1h0l-0.1,0C1.7,4.4,0.4,5.7,0.1,7.2l0,0C-0.4,10,2,12.4,4.7,11.9l0,0c0.5-0.1,0.9-0.3,1.3-0.5L8,13.4
			c-1.2,1.9-2,4.2-2,6.6c0,2.4,0.7,4.7,2,6.6L6,28.6c-0.4-0.2-0.8-0.4-1.3-0.5l0,0C2,27.6-0.4,30,0.1,32.7l0,0
			c0.3,1.6,1.6,2.9,3.2,3.2l0.1,0h0C3.7,36,4,36.3,4.1,36.6v0l0,0.1c0.3,1.6,1.6,2.9,3.2,3.2l0,0c2.8,0.5,5.2-1.9,4.7-4.7l0,0
			c-0.1-0.5-0.3-0.9-0.5-1.3l1.6-1.6c0.2,1.5,1.5,2.6,3,2.6c0.8,0,1.5-0.3,2-0.8c0.5,0.5,1.2,0.8,2,0.8c0.8,0,1.5-0.3,2-0.8
			c0.5,0.5,1.2,0.8,2,0.8c1.5,0,2.8-1.1,3-2.6l1.6,1.6c-0.2,0.4-0.4,0.8-0.5,1.3l0,0c-0.5,2.8,1.9,5.2,4.7,4.7l0,0
			c1.6-0.3,2.9-1.6,3.2-3.2l0-0.1v0c0.1-0.3,0.3-0.6,0.7-0.7h0l0.1,0c1.6-0.3,2.9-1.6,3.2-3.2l0,0c0.5-2.8-1.9-5.2-4.7-4.7l0,0
			c-0.5,0.1-0.9,0.3-1.3,0.5L32,26.6c1.2-1.9,2-4.2,2-6.6c0-2.4-0.7-4.7-2-6.6l1.9-1.9c0.4,0.2,0.8,0.4,1.3,0.5l0,0
			c2.8,0.5,5.2-1.9,4.7-4.7l0,0c-0.3-1.6-1.6-2.9-3.2-3.2l-0.1,0h0C36.3,4,36,3.7,36,3.4v0l0-0.1C35.6,1.7,34.4,0.4,32.7,0.1
			L32.7,0.1z M25.7,10.3l0.3,0.2c0.8,0.4,1.6,1,2.3,1.6c2.3,2,3.8,4.9,3.8,8c0,2.2-0.7,4.3-2,6l-0.1,0.1c-1,1.4-2.4,2.5-4,3.4
			l-0.3,0.1c0,0-0.1,0-0.1,0.1L25,30v0l-0.2,0.1l0.2,0.2V32c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-2h-2v2c0,0.5-0.5,1-1,1
			c-0.5,0-1-0.5-1-1v-2h-2v2c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-1.6l0.2-0.2L15,30.1v0l-0.6-0.3c0,0-0.1,0-0.1-0.1L14,29.5
			c-1.6-0.8-3-2-4-3.4L10,26c-1.2-1.7-2-3.8-2-6c0-2.3,0.7-4.4,2-6.1l0,0l0,0l0,0c1-1.4,2.4-2.5,4-3.4C15.8,9.5,17.8,9,20,9
			C22.1,9,24,9.5,25.7,10.3z M30.8,11.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.7-0.8-1.6-1.5-2.5-2.1l3.2-3.2l-0.7-0.7
			c-0.3-0.3-0.5-0.6-0.6-1C29.8,3,31,1.8,32.4,2c0.7,0.1,1.4,0.7,1.6,1.5v0l0,0.1c0.2,1.2,1.2,2.2,2.4,2.4l0.1,0h0
			c0.7,0.2,1.4,0.8,1.5,1.6C38.2,9,37,10.2,35.6,10c-0.4-0.1-0.7-0.3-1-0.6l-0.7-0.7L30.8,11.8z M28.1,30.6c0.5-0.3,1-0.7,1.4-1.1
			c0.5-0.4,0.9-0.8,1.3-1.3l3.1,3.1l0.7-0.7c0.3-0.3,0.6-0.5,1-0.6c1.4-0.3,2.6,0.9,2.4,2.4c-0.1,0.8-0.8,1.4-1.5,1.6h0l-0.1,0
			c-1.2,0.2-2.2,1.2-2.4,2.4l0,0.1v0c-0.2,0.8-0.8,1.4-1.6,1.5C31,38.2,29.8,37,30,35.6c0.1-0.4,0.3-0.7,0.6-1l0.7-0.7L28.1,30.6z
			 M10.5,29.6c0.5,0.4,0.9,0.7,1.4,1.1l-3.2,3.2l0.7,0.7c0.3,0.3,0.5,0.6,0.6,1C10.2,37,9,38.2,7.6,38c-0.7-0.1-1.4-0.7-1.6-1.5v0
			l0-0.1c-0.2-1.2-1.2-2.2-2.4-2.4l-0.1,0h0c-0.7-0.2-1.4-0.8-1.5-1.6C1.8,31,3,29.8,4.4,30c0.4,0.1,0.7,0.3,1,0.6l0.7,0.7l3.1-3.1
			C9.6,28.7,10,29.2,10.5,29.6z M10.7,10.3c-0.5,0.4-1,0.9-1.5,1.5L6.1,8.7L5.4,9.4c-0.3,0.3-0.6,0.5-1,0.6C3,10.2,1.8,9,2,7.6
			c0.1-0.8,0.8-1.4,1.5-1.6h0l0.1,0C4.9,5.8,5.8,4.9,6,3.7l0-0.1v0C6.2,2.8,6.9,2.2,7.6,2C9,1.8,10.2,3,10,4.4
			c-0.1,0.4-0.3,0.7-0.6,1L8.7,6.1L12,9.4C11.5,9.7,11.1,10,10.7,10.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Skull
};
